// extracted by mini-css-extract-plugin
module.exports = {"noDomains":"styles_noDomains__3GZtd","centered":"styles_centered__1crQ7","icon":"styles_icon__1pwbq"};